import { setPageTitle } from "@/helpers/page";

export default function ({ next, to }) {
  setPageTitle(to.meta.title);

  return next();
}
